import React, { useState } from "react";
import { useCreateProjectMutation } from "../Features/projects/projectsApi";
import { useGetTeamsDataQuery } from "../Features/teams/teamsApi";

const CreateProject = ({ control, isOpen, backlogData }) => {
    const [selectedTeam, setSelectedTeam] = useState(null);
    const [projectDesc, setProjectDesc] = useState("");
    const { data: teams } = useGetTeamsDataQuery();
    const [createProject, { isLoading }] = useCreateProjectMutation();

    const projectHandler = async (e) => {
        e.preventDefault();
        const team = teams?.find((t) => t.id === parseInt(selectedTeam));

        await createProject({
            description: projectDesc,
            team: team,
            timestamp: new Date().getTime(),
        });
        control();
    };
    return (
        isOpen && (
            <>
                <div
                    className="fixed w-full h-full inset-0 z-10 bg-black/50 cursor-pointer"
                    onClick={control}
                ></div>
                <div className="rounded w-[400px] lg:w-[600px] space-y-8 bg-white p-10 absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2">
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                        Create Project
                    </h2>
                    <form className="mt-8 space-y-6" onSubmit={projectHandler}>
                        <div className="rounded-md shadow-sm -space-y-px">
                            <div>
                                <label htmlFor="color" className="sr-only">
                                    Color
                                </label>
                                <select
                                    id="color"
                                    name="to"
                                    type="text"
                                    required
                                    className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                                    placeholder="Choose a team color"
                                    value={selectedTeam?.name}
                                    onChange={(e) =>
                                        setSelectedTeam(e.target.value)
                                    }
                                >
                                    <option value="">Choose a team</option>
                                    {teams?.map((t) => {
                                        return (
                                            <option key={t?.id} value={t?.id}>
                                                {t?.name}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                            <div>
                                <label
                                    htmlFor="description"
                                    className="sr-only"
                                >
                                    Description
                                </label>
                                <textarea
                                    id="description"
                                    name="message"
                                    type="text"
                                    required
                                    className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                                    placeholder="Project Descrption"
                                    value={projectDesc}
                                    onChange={(e) =>
                                        setProjectDesc(e.target.value)
                                    }
                                />
                            </div>
                        </div>

                        <div>
                            <button
                                type="submit"
                                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
                                disabled={isLoading}
                            >
                                Create
                            </button>
                        </div>
                    </form>
                </div>
            </>
        )
    );
};

export default CreateProject;
